import React, { FC } from 'react';
import { Hyperlink } from '../../components/Hyperlink';
import styles from './footer_item.module.scss';

type Props = {
  href: string;
  onClick?: () => void;
  target?: string | undefined;
  rel?: string | undefined;
  source?: string;
  shouldBeRemovedBySnapshots?: boolean;
  forceKeepInSnapshot?: boolean;
};

export const FooterItem: FC<Props> = ({
  children,
  href,
  onClick = () => {},
  target,
  rel,
  source = '',
  shouldBeRemovedBySnapshots = false,
  forceKeepInSnapshot = false,
}) => (
  <Hyperlink
    className={styles.item}
    href={href}
    onClick={onClick}
    target={target}
    rel={rel}
    source={source}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(shouldBeRemovedBySnapshots && {
      'data-snapshot': 'disable-href',
    })}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(forceKeepInSnapshot && {
      'data-snapshot': 'keep',
    })}
  >
    {children}
  </Hyperlink>
);
